<!-- <p-card *ngIf="!mzTabResult" header="Loading data..."> -->
@if (!mzTabResult) {
  <p-progress-spinner ariaLabel="loading" class="flex w-full p-3"></p-progress-spinner>
}
@if (mzTabResult && !detailView) {
  <div>
    @if (!detailView) {
      <div>
        <div class="flex flex-row align-items-start py-1 flex-wrap">
          <div class="flex flex-row flex-grow-1 w-full align-content-center justify-content-between flex-wrap bg-gray-100 dark:bg-gray-700 p-1 mb-1 border-round">
            <!-- Show Publication status, datePublished, dateCreated, dateLastModified, revision -->
            <div class="p-1 m-1 flex align-items-center">
              <span class="fas fa-eye fa-fw" aria-hidden="true"></span>&nbsp;Status:&nbsp;
              @if (mzTabResult?.visibility === 'PRIVATE') {
                <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                class="fa fa-lock p-tag p-tag-danger p-1 m-1" aria-hidden="true"></span>
              }
              @if (mzTabResult?.visibility === 'RESTRICTED') {
                <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                  class="fa fa-lock p-tag p-tag-warning p-1 m-1"
                aria-hidden="true"></span>
              }
              @if (mzTabResult?.visibility === 'PUBLIC') {
                <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                class="fa fa-lock-open p-tag p-tag-success p-1 m-1" aria-hidden="true"></span>
              }
              @if (mzTabResult?.submissionStatus) {
                <span title="{{ 'Publication Status: ' + mzTabResult?.submissionStatus }}"
                    class="p-tag p-tag-info p-1 m-1">{{ mzTabResult?.submissionStatus }}</span>
              }
            </div>
            <!-- @if (mzTabResult?.datePublished) {
              <div class="p-1 m-1 flex align-items-center">
                Released:&nbsp;
                <span title="Date Released"
                  class="p-tag p-tag-info p-1 m-1">{{ study?.datePublished | date:'medium' }}</span>
              </div>
            } -->
            <!-- @if (mzTabResult?.dateCreated) {
              <div class="p-1 m-1 flex align-items-center">
                Created:&nbsp;
                <span title="Date Created"
                  class="p-tag p-tag-info p-1 m-1">{{ mzTabResult?.dateCreated | date:'medium' }}</span>
              </div>
            }
            @if (mzTabResult?.dateLastModified) {
              <div class="p-1 m-1 flex align-items-center">
                Last modified:&nbsp;
                <span title="Date Last Modified"
                  class="p-tag p-tag-info p-1 m-1">{{ mzTabResult?.dateLastModified | date:'medium' }}</span>
              </div>
            } -->
            <!-- add license -->
            <!-- <div class="p-1 m-1 flex align-items-center">
              License:&nbsp;
              @if (mzTabResult?.studySummary?.dataLicense) {
              <span class="p-tag p-tag-info p-1 m-1"><a href="{{ study?.studySummary?.dataLicense?.link }}" class="external-link text-white" title="{{ study?.studySummary?.dataLicense?.licenseName }}">{{ 'LICENSES.'+study?.studySummary?.dataLicense?.licenseId | translate }}&nbsp;<span
                          class="fa fa-external-link-alt" aria-hidden="true"></span></a></span>
              }
              @if ( !(mzTabResult?.studySummary?.dataLicense)) {
                <span class="p-tag p-tag-warning p-1 m-1" title="No data license set">No license set</span>
              }
            </div> -->
          </div>
        </div>
        <div class="flex flex-row align-items-start py-1 flex-wrap">
          <div class="w-3 flex-shrink-0 align-content-center">
            <span class="fa fa-flask fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Title
          </div>
          <div class="flex-1">
            <span>@if (showDatasetLink) {
              <a [routerLink]="['/dataset/pid/' + mzTabResult?.nativeId]"><strong>{{
              mzTabResult?.mzTabSummary?.title }}</strong></a>
              }<span class="text-surface-600 dark:text-surface-200">&nbsp;({{ mzTabResult?.nativeId }})</span></span>
              @if (!showDatasetLink) {
                <span><b>{{ mzTabResult?.mzTabSummary?.title }}</b><span class="text-surface-600 dark:text-surface-200">&nbsp;({{ mzTabResult?.nativeId }})</span></span>
              }
              <!-- TODO: add dataset card downloadFile function similar to submissionComponent downloadFile function -->
            </div>
          </div>
          <!-- <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-eye fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Status
            </div>
            <div class="flex-1">
              @if (mzTabResult?.visibility === 'PRIVATE') {
                <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                class="fa fa-lock p-tag p-tag-danger p-1 m-1" aria-hidden="true"></span>
              }
              @if (mzTabResult?.visibility === 'RESTRICTED') {
                <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                class="fa fa-lock p-tag p-tag-warning p-1 m-1" aria-hidden="true"></span>
              }
              @if (mzTabResult?.visibility === 'PUBLIC') {
                <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                class="fa fa-lock-open p-tag p-tag-success p-1 m-1" aria-hidden="true"></span>
              }
              <span title="{{ 'Submission Status: ' + mzTabResult?.submissionStatus }}" class="p-tag p-tag-info p-1 m-1">{{
              "SUBMISSION_STATUS." + mzTabResult?.submissionStatus | uppercase | translate}}</span>
            </div>
          </div> -->
          <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-star fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Curation Level
            </div>
            <div class="flex-1">
              <div class="flex flex-row align-content-center justify-content-start my-1 py-1  ">
                @if (curationLevel) {
                  <p-rating [(ngModel)]="curationLevel.value" [readonly]="true" cancel="false" [stars]="curationLevel.ncases"
                    class="flex" />
                }
                @if (curationLevel) {
                  <div class="flex flex-grow-1 vertical-align-text-bottom pl-3">{{ "CURATION_LEVEL." + curationLevel?.label | uppercase |
                  translate }}</div>
                }
              </div>
            </div>
          </div>
          <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-gauge fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Level
            </div>
            <div class="flex flex-1 align-content-center py-1 my-1">
              {{ "COMPLETENESS." + mzTabResult?.completeness | uppercase | translate }}
            </div>
          </div>
          @if (showClassifications) {
            <app-cvparameter-classification [cvParameters]="mzTabResult?.cvParameters"
            ></app-cvparameter-classification>
          }
          <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-weight fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Database Quantification Unit
            </div>
            <div class="flex flex-1 align-content-center">
              <span class="p-tag p-tag-success p-1 m-1 classification">
                <app-olslink [param]="mzTabResult?.mzTabSummary?.quantificationUnit" [displayValue]="true"></app-olslink>&nbsp;
                <app-olslink [param]="mzTabResult?.mzTabSummary?.quantificationUnit" [displayValue]="false" [linkOnly]="true"></app-olslink>
              </span>
            </div>
          </div>
          <div class="flex flex-row align-items-start py-1">
            <div class="w-3 flex-shrink-0 align-content-center">
              <span class="fas fa-weight fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Original Quantification Unit
            </div>
            <div class="flex flex-1 align-content-center">
              <span class="p-tag p-tag-secondary p-1 m-1 classification">
                <app-olslink [param]="mzTabResult?.mzTabSummary?.nativeQuantificationUnit" [displayValue]="true"></app-olslink>&nbsp;
                <app-olslink [param]="mzTabResult?.mzTabSummary?.nativeQuantificationUnit" [displayValue]="false" [linkOnly]="true"></app-olslink>
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (mzTabResult && detailView) {
    <p-card class="">
      @if (detailView) {
        <ng-template pTemplate="title">
          <div class="p-card-title">{{ mzTabResult?.mzTabSummary?.id }}</div>
        </ng-template>
      }
    @if (detailView) {
      <p-panel header="Dataset Details" [toggleable]="toggleable">
        <div class="flex flex-column">
          <div class="p-2 m-2">
            @if (showDatasetLink) {
              <div class="flex flex-row align-items-start py-1">
                <div class="w-3 flex-shrink-0 align-content-center">
                  <span class="fa fa-vials fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Study
                </div>
                <div class="flex flex-1 align-content-center">
                  <span class="my-1 py-1">
                    <a [routerLink]="['/study/pid/' + mzTabResult.nativeId?.substring(0,9)]"><strong>{{
                    mzTabResult.nativeId?.substring(0,9) }}</strong></a>
                  </span>  
                </div>
              </div>
            }
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fa fa-flask fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Title
              </div>
              <div class="flex flex-1 align-content-center">
                <span class="my-1 py-1">@if (showDatasetLink) {
                  <a [routerLink]="['/dataset/pid/' + mzTabResult?.nativeId]"><strong>{{
                  mzTabResult?.mzTabSummary?.title }}</strong></a>
                }</span>
                @if (!showDatasetLink) {
                  <span class="my-1 py-1"><strong>{{ mzTabResult?.mzTabSummary?.title }}</strong></span>
                }
              </div>
            </div>
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fa fa-stream fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Description
              </div>
              <div class="flex flex-1 align-content-center">
                <span class="my-1 py-1">{{ mzTabResult?.mzTabSummary?.description }}</span>
              </div>
            </div>
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fas fa-eye fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Status
              </div>
              <div class="flex-1">
                @if (mzTabResult?.visibility === 'PRIVATE') {
                  <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                  class="fa fa-lock p-tag p-tag-danger p-1 m-1" aria-hidden="true"></span>
                }
                @if (mzTabResult?.visibility === 'RESTRICTED') {
                  <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                    class="fa fa-lock p-tag p-tag-warning p-1 m-1"
                  aria-hidden="true"></span>
                }
                @if (mzTabResult?.visibility === 'PUBLIC') {
                  <span title="{{ 'Visibility: ' + mzTabResult?.visibility }}"
                  class="fa fa-lock-open p-tag p-tag-success p-1 m-1" aria-hidden="true"></span>
                }
                <span title="{{ 'Publication Status: ' + mzTabResult?.submissionStatus }}"
                class="p-tag p-tag-info p-1 m-1">{{ mzTabResult?.submissionStatus }}</span>
              </div>
            </div>
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fas fa-gauge fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Level
              </div>
              <div class="flex flex-1 align-content-center">
                <span class="my-1 py-1">{{ "COMPLETENESS." + mzTabResult?.completeness | uppercase | translate }}</span>
              </div>
            </div>
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fa fa-address-book fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Study Contacts
              </div>
              <div class="flex-1 align-content-center">
                @for (contact of mzTabResult?.mzTabSummary?.contacts; track contact) {
                  <div>
                    <span>{{ contact.name }}</span><br />
                    <span class="text-surface-600 dark:text-surface-200">{{ contact.affiliation }}</span>
                  </div>
                }
              </div>
            </div>
            <!-- TODO: retrieve submission info separately from submission field -->
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fa fa-file-alt fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Publications
              </div>
              <div class="flex-1 align-content-start my-1 py-1">
                @for (publication of mzTabResult?.mzTabSummary?.publications; track publication) {
                  <div>
                    @for (publicationItem of publication.publicationItems; track publicationItem) {
                      <div>
                        @if (publicationItem.type === 'doi') {
                          <div>
                            <a href="{{ 'https://doi.org/' + publicationItem.accession }}" target="_blank"
                              class="external-link" title="External: Access article via DOI"><span>{{
                              publicationItem.type + ": " + publicationItem.accession
                              }}</span>&nbsp;<span class="fa fa-external-link-alt" aria-hidden="true"></span></a>
                            </div>
                          }
                          @if (publicationItem.type === 'pubmed') {
                            <div>
                              <span>{{
                                publicationItem.type + ": " + publicationItem.accession
                            }}</span>&nbsp;<a href="{{
                              'https://pubmed.ncbi.nlm.nih.gov/' +
                                publicationItem.accession
                            }}" target="_blank" class="external-link" title="External: Access article on PubMed"><span class="fa fa-external-link-alt"
                            aria-hidden="true"></span></a>
                          </div>
                        }
                        @if (publicationItem.type === 'uri') {
                          <div>
                            <span>{{
                              publicationItem.type + ": " + publicationItem.accession
                            }}</span>&nbsp;<a href="{{ publicationItem.accession }}" target="_blank" class="external-link" title="External: Access article via accession url"><span
                          class="fa fa-external-link-alt" aria-hidden="true"></span></a>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            @if (showClassifications) {
              <hr />
              <app-cvparameter-classification [cvParameters]="mzTabResult?.cvParameters"
              ></app-cvparameter-classification>
            }
            <hr />
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fas fa-weight fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Database Quantification Unit
              </div>
              <div class="flex flex-1 align-content-center">
                <span class="p-tag p-tag-success p-1 m-1 classification">
                  <app-olslink [param]="mzTabResult?.mzTabSummary?.quantificationUnit" [displayValue]="true"></app-olslink>&nbsp;
                  <app-olslink [param]="mzTabResult?.mzTabSummary?.quantificationUnit" [displayValue]="false" [linkOnly]="true"></app-olslink>
                </span>
              </div>
            </div>
            <div class="flex flex-row align-items-start py-1">
              <div class="w-3 flex-shrink-0 align-content-center">
                <span class="fas fa-weight fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Original Quantification Unit
              </div>
              <div class="flex flex-1 align-content-center">
                <span class="p-tag p-tag-secondary p-1 m-1 classification">
                  <app-olslink [param]="mzTabResult?.mzTabSummary?.nativeQuantificationUnit" [displayValue]="true"></app-olslink>&nbsp;
                  <app-olslink [param]="mzTabResult?.mzTabSummary?.nativeQuantificationUnit" [displayValue]="false" [linkOnly]="true"></app-olslink>
                </span>
              </div>
            </div>
            <hr />
            <!-- Stats: two equal columns, each with label/value rows -->
            <div class="flex flex-row flex-wrap gap-3">
              <div class="flex-1 min-w-0 flex flex-column">
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-project-diagram fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Study Variable Levels
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.studyVariableCount
                    | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-vial fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Samples
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.sampleCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-th fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Assays
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.assayCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-chart-bar fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;MS Runs
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.msRunCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
              </div>
              <div class="flex-1 min-w-0 flex flex-column">
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fas fa-th-list fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Quantities
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.assayCount *
                    mzTabResult?.mzTabSummary?.smlCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-chart-pie fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;Summary Entries
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.smlCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-fingerprint fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;MS Features
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.smfCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
                <div class="flex flex-row align-items-center py-1">
                  <div class="w-6 flex-shrink-0">
                    <span class="fa fa-search fa-fw my-1 py-1" aria-hidden="true"></span>&nbsp;MS Evidence
                  </div>
                  <div class="flex-1">
                    {{
                    mzTabResult?.mzTabSummary?.smeCount | number: "1.0-0":"en-US"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-panel>
    }
    @if (detailView && showPlots) {
      <app-dataset-detail-plots [mzTabResult]="mzTabResult"></app-dataset-detail-plots>
    }
    </p-card>
  }
